import { Skeleton, Stack, useTheme } from "@mui/material";

const TaskSkeleton = () => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      spacing={theme.nawy.spacing.xs}
      alignItems="start"
      alignSelf="stretch"
    >
      {/* Simulated Circular Checkbox */}
      <Skeleton variant="circular" width={20} height={20} />

      <Stack direction="column" spacing={theme.nawy.spacing.xxs}>
        {/* Description Line */}
        <Skeleton variant="rectangular" width="200px" height={18} />

        {/* Date Line */}
        <Skeleton variant="rectangular" width="150px" height={16} />

        {/* Added by and UserNameTag */}
        <Stack
          direction="row"
          alignItems="center"
          spacing={theme.nawy.spacing.xs}
        >
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="rectangular" width="80px" height={14} />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default TaskSkeleton;

